/* stylelint-disable no-descending-specificity */
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import {
  Header,
  HeaderItem,
  Sidebar,
  SidebarItem,
  SidebarPageWrapper,
  SidebarFooter,
} from '@trueprodigy/components';

import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose, lifecycle } from 'recompose';
import styled from 'styled-components';

import HeaderZendeskWidget from '@components/HeaderZendeskWidget/HeaderZendeskWidget';
import SidebarCaseSettingWidget from '@components/Sidebar/SidebarCaseSettingWidget';
import SidebarAccountSettingsWidget from '@components/Sidebar/SidebarAccountSettingsWidget';
import HeaderWrapper from '@components/HeaderWrapper';
import * as globalActions from '@actions/global';
import {
  isSidebarVisibleSelector,
  userRightsSelector,
  userStatusSelector,
} from '@selectors/global';
import {
  fetchAppraisalYears,
  fetchCurrentAppraisalYear,
} from '@modules/appraisal/actions/global';

import { AuditsRoutes } from '../constants';
import ability, { defineRules } from '@config/permissions/ability';

import screenIcon from '../../../assets/images/print-screen-tp-01.svg';
import auditLogo from '@assets/images/true-prodigy-logo-audits.png';
import rocketIcon from '@components/Sidebar/assets/rocket-icon.png';

const parseHeaderTitle = ({ pathname }) => {
  if (pathname === AuditsRoutes.AuditRuns) return 'HS Audit Runs';
  return '';
};

const PageWrapper = ({
  children,
  isSidebarVisible,
  location,
  toggleSidebar,
  userRights,
  // userStatus,
}) => {
  // const isReadOnly = userStatus.get('readOnly');

  useEffect(() => {
    if (userRights && userRights.toJS() && userRights.toJS().length) {
      const rules = defineRules(userRights.toJS());
      ability.update(rules);
    }
  }, [userRights]);

  useEffect(() => {
    const isiPad = navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints;
    if (isSidebarVisible && isiPad) {
      toggleSidebar();
    }
  }, [location.pathname]);

  return (
    <Container>
      <Helmet>
        <title>Audits</title>
      </Helmet>
      <Sidebar
        isSidebarVisible={isSidebarVisible}
        logo={auditLogo}
        sidebarFooter={
          <SidebarFooter>
            <SidebarCaseSettingWidget />
            <SidebarAccountSettingsWidget />
          </SidebarFooter>
        }
      >
        <SidebarItem icon={rocketIcon} link="/" title="Prodigy App Launcher" />
        <SidebarItem link={AuditsRoutes.AuditRuns} title="Audit Runs" />
      </Sidebar>
      <PageWrapper.ContentWrapper>
        <SidebarPageWrapper isSidebarVisible={isSidebarVisible}>
          <HeaderContainer>
            <HeaderWrapper>
              <Header
                title={parseHeaderTitle(location)}
                toggleSidebar={toggleSidebar}
              >
                <HeaderItem
                  icon={screenIcon}
                  title="Print Screen"
                  onClick={() => window.print()}
                />
                <HeaderZendeskWidget color="white" />
              </Header>
            </HeaderWrapper>
          </HeaderContainer>

          <div>{children}</div>
        </SidebarPageWrapper>
      </PageWrapper.ContentWrapper>
    </Container>
  );
};

PageWrapper.propTypes = {
  children: PropTypes.node,
  fetchAppraisalYears: PropTypes.func,
  fetchCurrentAppraisalYear: PropTypes.func,
  history: PropTypes.object.isRequired,
  isSidebarVisible: PropTypes.bool,
  location: PropTypes.object.isRequired,
  toggleSidebar: PropTypes.func.isRequired,
  userRights: ImmutablePropTypes.list,
  userStatus: PropTypes.any,
};

const Container = styled.div`
  .deepNested {
    a {
      margin-left: 20px;
    }
  }
`;

const HeaderContainer = styled.div`
  color: #fff !important;

  > div > div > div > div > div {
    color: #fff;

    i {
      color: #fff;
    }
  }
`;

PageWrapper.ContentWrapper = styled.div`
  > div {
    margin-top: -67px;
    min-height: 100vh;
    background-color: #f2f4f6;
  }
`;

const mapStateToProps = (state) => ({
  isSidebarVisible: isSidebarVisibleSelector(state),
  userRights: userRightsSelector(state),
  userStatus: userStatusSelector(state),
});

const mapDispatchToProps = {
  toggleSidebar: globalActions.toggleSidebar,
  fetchAppraisalYears: fetchAppraisalYears,
  fetchCurrentAppraisalYear: fetchCurrentAppraisalYear,
};

const enhance = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.fetchAppraisalYears();
      this.props.fetchCurrentAppraisalYear();
    },
  }),
);

export default enhance(PageWrapper);
